'use client';

import React from 'react';
import { IdView } from '../../../../components';
import { RevshareSubscriber } from '../types';

interface IdCellProps {
  subscriber: RevshareSubscriber;
}

const IdCell: React.FC<IdCellProps> = ({ subscriber }) => {
  // Use of_user_id if available, otherwise use id or _id
  const idValue = subscriber.id?.toString() || subscriber.of_user_id || subscriber._id || '';
  const displayId = idValue.slice(-4);

  return (
    <div className="flex items-center">
      <IdView textToCopy={idValue}>{displayId}</IdView>
    </div>
  );
};

export default IdCell;
